/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".scrollDisabled_11e8d933{overflow:hidden !important}\n" }]);
export var scrollDisabled = "scrollDisabled_11e8d933";
//# sourceMappingURL=scroll.scss.js.map